module.exports = require("./fr-MU.js");